export default "__VITE_ASSET__2016ed27__"